"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoIterator = void 0;
var PromoIterator = (function () {
    function PromoIterator(promos) {
        this.currentIndex = null;
        this.promos = promos;
    }
    PromoIterator.prototype.getPromo = function () {
        var targetIndex;
        if (this.currentIndex === null) {
            targetIndex = 0;
        }
        else if (this.currentIndex === this.promos.length - 1) {
            targetIndex = 0;
        }
        else {
            targetIndex = this.currentIndex + 1;
        }
        this.currentIndex = targetIndex;
        return this.promos[targetIndex];
    };
    PromoIterator.prototype.skipToPromo = function (promoId) {
        var index = this.promos.map(function (promo) { return promo.id; }).indexOf(promoId);
        this.currentIndex = index < 0 ? 0 : index;
    };
    PromoIterator.prototype.resetIndex = function () {
        this.currentIndex = 0;
    };
    return PromoIterator;
}());
exports.PromoIterator = PromoIterator;
//# sourceMappingURL=PromoIterator.js.map